import { IsEmail, IsOptional, IsString, MaxLength } from 'class-validator';

export class CreateSessionDto {
  // All optional — a session is guest-friendly by default. Only populated if
  // the host app calls identify() on a signed-in user.
  @IsOptional()
  @IsString()
  @MaxLength(255)
  externalUserId?: string;

  @IsOptional()
  @IsString()
  @MaxLength(255)
  externalUserName?: string;

  @IsOptional()
  @IsEmail()
  externalUserEmail?: string;
}
